import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';

const apiToken = process.env.REACT_APP_API_TOKEN;

const slice = createSlice({
  name: 'accounts',
  initialState: {
    list: []
  },
  reducers: {
    accountsLoaded: (accounts, action) => {
      accounts.list = action.payload.data;
    },

    accountsChanged: (accounts, action) => {
      const { accountId, amount } = action.payload.params;
      const index = accounts.list.findIndex(a => a.account_id === accountId);
      accounts.list[index].balance += parseInt(amount);
    },
    accountHistoryLoaded: (accounts, action) => {
      const { accountId } = action.payload.params;
      const index = accounts.list.findIndex(a => a.account_id === accountId);
      accounts.list[index].history = action.payload.data;
    },
    visibilityChanged: (accounts, action) => {
      const { accountId } = action.payload.params;
      const index = accounts.list.findIndex(a => a.account_id === accountId);
      accounts.list[index].visibility = !accounts.list[index].visibility ;
    }
  }
});

const { accountsLoaded, accountsChanged, accountHistoryLoaded,visibilityChanged } = slice.actions;
export default slice.reducer;

// Action Creators

export const loadAccounts = () => async (dispatch, getState) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/accounts/?secret_key=${apiToken}`,
      onSuccess: accountsLoaded.type,
      actionName: 'loadAccounts'
    })
  );
};

export const loadAccountHistory = ({ accountId }) => async (
  dispatch,
  getState
) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/accounts/${accountId}/?secret_key=${apiToken}`,
      onSuccess: accountHistoryLoaded.type,
      params: { accountId },
      actionName: 'loadAccountHistory'
    })
  );
};


export const changeVisibility = (accountId ) => async (
  dispatch,
  getState
) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/accounts/${accountId}/visibility/?secret_key=${apiToken}`,
      method: 'patch',
      onSuccess: visibilityChanged.type,
      params: { accountId },
      actionName: 'changeVisibility'
    })
  );
};




export const addAccountPayment = ({ accountId, amount, comment }) =>
  apiCallBegan({
    url: `/api/accounts/${accountId}/?amount=${amount}&comment=${comment}&secret_key=${apiToken}`,
    method: 'post',
    data: { account_id: accountId, amount, comment },
    onSuccess: accountsChanged.type,
    actionName: 'addAccountPayment',
    params: { accountId, amount }
  });

// Selectors

export const getAccountsSelector = createSelector(
  state => state.entities.accounts.list,
  accounts => accounts
);

// Helpers methods
